import {
  mainCommandReceiptSegments,
  type MainCommandRecipientStatus,
} from '../lib/main-command-delivery';

export function MainCommandReceipt({ statuses }: { readonly statuses: readonly MainCommandRecipientStatus[] }) {
  const segments = mainCommandReceiptSegments(statuses);
  if (segments.length === 0) return null;
  const summary = segments.map((segment) => `${segment.label}: ${segment.count}`).join('. ');

  return (
    <details className="main-command-receipt" data-testid="main-command-receipt">
      <summary aria-label={`Message receipt. ${summary}`} title={summary}>
        {segments.map((segment) => (
          <span
            key={segment.state}
            className={`main-command-receipt-segment tone-${segment.tone}`}
            data-receipt-state={segment.state}
            aria-label={`${segment.label}: ${segment.count}`}
            title={`${segment.label}: ${segment.count}`}
          >
            <span aria-hidden="true">{segment.symbol}</span>
            <small>{segment.count}</small>
          </span>
        ))}
      </summary>
      <span className="main-command-receipt-details" aria-label="Participant delivery status">
        {statuses.map((status) => (
          <small key={status.key} data-recipient-status={status.state}>
            <strong>{status.label}</strong>{' · '}{status.text}
          </small>
        ))}
      </span>
    </details>
  );
}
